import { Stack } from '@/components/layout';
import { STRINGS } from '@/constants/strings';
import QuickLinkCard from '@/features/guardian-player/components/player-detail/quick-link-card';
import { useScaling } from '@/hooks';
import React from 'react';

const strings = STRINGS.guardianPlayer.playerDetail;

type QuickLinksGridProps = {
  progressLabel: string;
  notesLabel: string;
  guardiansLabel: string;
  packageLabel: string;
  onPressProgress: () => void;
  onPressNotes: () => void;
  onPressGuardians: () => void;
  onPressPackage: () => void;
};

export default function QuickLinksGrid({
  progressLabel,
  notesLabel,
  guardiansLabel,
  packageLabel,
  onPressProgress,
  onPressNotes,
  onPressGuardians,
  onPressPackage,
}: QuickLinksGridProps) {
  const { scale } = useScaling();

  return (
    <Stack gap={scale(12)}>
      <Stack direction="row" gap={scale(12)}>
        <QuickLinkCard
          icon="IcPlayerIndexProgress"
          label={strings.cards.progress}
          value={progressLabel}
          onPress={onPressProgress}
        />
        <QuickLinkCard
          icon="IcPlayerIndexNotes"
          label={strings.cards.notes}
          value={notesLabel}
          onPress={onPressNotes}
        />
      </Stack>
      <Stack direction="row" gap={scale(12)}>
        <QuickLinkCard
          icon="IcPlayerIndexGuardian"
          label={strings.cards.guardians}
          value={guardiansLabel}
          onPress={onPressGuardians}
        />
        <QuickLinkCard
          icon="IcPlayerIndexPackage"
          label={strings.cards.package}
          value={packageLabel}
          onPress={onPressPackage}
        />
      </Stack>
    </Stack>
  );
}
